import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { Down, Up } from "assets/Icon";

import { useLocation } from "react-router-dom";
import { useMemo } from "react";

function MenuListItem({ item, showChildren, setShowChildren }) {
  const theme = useTheme();
  const location = useLocation();

  const handleClick = (item) => {
    if (item?.children) {
      if (item.key === showChildren) {
        setShowChildren(null);
      } else {
        setShowChildren(item.key);
      }
    } else if (item?.onClick) item?.onClick();
    else return;
  };

  const setIsActive = useMemo(() => {
    const checkIfChildIsActive = item?.children?.find(
      (child) => location?.pathname === child?.path
    );

    if (checkIfChildIsActive) return checkIfChildIsActive;
    else return location?.pathname === item?.path;
  }, [location?.pathname, item?.children, item?.path]);

  const isCollapsed = showChildren === item.key;

  return (
    <>
      {
        !item?.hide &&
        <ListItem disablePadding>
          <ListItemButtonParent
            isActive={setIsActive}
            onClick={() => handleClick(item)}
          >
            <ListItemParentName>
              {item.icon}

              <Typography
                ml={1}
                fontWeight={400}
                variant="subtitle3"
                color={setIsActive ? "secondary.main" : "text.main"}
              >
                {item.name}
              </Typography>
            </ListItemParentName>

            {item?.children && (
              <ListItemParentCollapseIcon>
                {isCollapsed ? (
                  <Up color={theme.palette.text.main} />
                ) : (
                  <Down color={theme.palette.text.main} />
                )}
              </ListItemParentCollapseIcon>
            )}
          </ListItemButtonParent>
        </ListItem>
      }

      {item?.children && (
        <Collapse in={isCollapsed} timeout="auto" unmountOnExit>
          <List component="div">
            {item?.children?.map((child) => (
              <>
                {!child?.hide &&
                  <ListItemStyle disablePadding key={child.key}>
                    <ListItemButtonChild
                      onClick={() => {
                        child?.onClick && child?.onClick();
                      }}
                    >
                      <Typography
                        variant="label"
                        color={
                          location.pathname === child?.path ||
                            location.pathname + location.search === child?.path
                            ? "secondary.main"
                            : "text.main"
                        }
                      >
                        {child.name}
                      </Typography>
                    </ListItemButtonChild>
                  </ListItemStyle>
                }
              </>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}

const ListItemButtonParent = styled(ListItemButton)(({ theme, isActive }) => ({
  padding: theme.spacing(1.5),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  borderLeft: isActive ? `3px solid ${theme.palette.secondary.main}` : "",
  background: isActive
    ? theme.palette.modules.sideMenuSecondaryDesktop
    : "transparent",
  svg: {
    path: {
      stroke: isActive ? theme.palette.secondary.main : theme.palette.text.main,
    },
  },
  "&:hover": {
    background: theme.palette.modules.sideMenuSecondaryDesktop,
  },
}));

const ListItemStyle = styled(ListItem)(({ theme, isActive }) => ({
  "&:hover": {
    background: theme.palette.modules.sideMenuSecondaryDesktop,
  },
}));

const ListItemButtonChild = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(1, 2),
}));

const ListItemParentName = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const ListItemParentCollapseIcon = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export default MenuListItem;
